import { render, staticRenderFns } from "./ValoracionInventario.vue?vue&type=template&id=0630ded3"
import script from "./ValoracionInventario.vue?vue&type=script&lang=js"
export * from "./ValoracionInventario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports